import React, { useState, useEffect } from 'react';
import { useGenHistoryItemEventHooks } from '@shakkerai/pro-gen-history';
import { SharePopover } from '@shakkerai/pro-components';
import { Icon } from '@shakkerai/components';
import { useShareImgModalStore, useUserInfo } from '@shakkerai/pro-store';
import { toUserPage } from '@shakkerai/pro-constants';
import { requestTaskDetail } from '@shakkerai/services';
// import { getImageDetailInfo } from '@shakkerai/services';

const IMAGE_INFO_CACHE = {};

export const ImageShareButton = ({ imageInfo, onMouseLeave, onMouseOver, children, className }) => {
  const { innerTaskId, innerImageId } = imageInfo;
  const [sharePopoverOpened, setSharePopoverOpened] = useState(false);
  const { showShareImgModal } = useShareImgModalStore();
  const userUuId = useUserInfo((state) => state.userInfo?.uuid);
  const { shareContent } = useGenHistoryItemEventHooks({
    itemInfo: {
      generateId: innerTaskId,
      outputId: innerImageId,
    },
  });
  const [innerImageInfo, setInnerImageInfo] = useState({});

  useEffect(() => {
    if (imageInfo) {
      setInnerImageInfo(imageInfo);
    }
  }, [imageInfo]);

  useEffect(() => {
    const getDetailInfo = async () => {
      // 缓存请求数据
      let taskDetail = null;
      if (IMAGE_INFO_CACHE[innerTaskId]) {
        taskDetail = IMAGE_INFO_CACHE[innerTaskId];
      } else {
        const res = await requestTaskDetail({ generateId: innerTaskId });
        if (res?.code === 0 && res?.data?.taskParam) {
          taskDetail = res.data || {};
          IMAGE_INFO_CACHE[innerTaskId] = taskDetail;
        }
      }

      if (taskDetail) {
        const image = taskDetail?.images?.find((i) => i.outputId === innerImageId);

        if (image) {
          const imageInfo = {
            ...image,
            innerTaskId: innerTaskId,
            innerImageId: innerImageId,
            url: image.imageId,
            genInfo: taskDetail?.taskParam?.projectData || {},
          };
          setInnerImageInfo(imageInfo);
        }
      }
    };
    if (innerTaskId && innerImageId && !imageInfo.genInfo && sharePopoverOpened) {
      getDetailInfo();
    }
  }, [imageInfo, innerTaskId, innerImageId, sharePopoverOpened]);

  // const [images, setImages] = useState([]);

  // useEffect(() => {
  //   const getImageInfos = async (id) => {
  //     const res = await getImageDetailInfo(id);
  //     if (res?.code === 0 && res?.data) {
  //       setImages(res.data);
  //     }
  //   };
  //   if (imageId) {
  //     getImageInfos(imageId);
  //   }
  // }, [imageId]);

  const showSharePopover = () => {
    setTimeout(() => {
      // mc('tool.canvas.share', { share_id: shareContent });
      setSharePopoverOpened(false);
    }, 200);
  };

  const handleSendShakker = () => {
    showShareImgModal({
      batchType: 2,
      imgInfo: innerImageInfo,
      onFinish() {
        window.open(toUserPage(userUuId || '', 'publish', 'image'), '_blank');
      },
    });
  };

  const handleClick = (event) => {
    setSharePopoverOpened(true);
    event.stopPropagation();
  };

  return (
    <SharePopover
      url={shareContent}
      imageId={innerImageId}
      opened={sharePopoverOpened}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onSendShakker={handleSendShakker}
      onClose={showSharePopover}
      imageInfo={innerImageInfo}
    >
      <button
        onClick={handleClick}
        style={{ backgroundColor: 'transparent' }}
        className={`${className} flex items-center justify-center font-normal text-[11px]`}
      >
        {!!children ? children : <Icon className="icon-External_Link" color="#fff" fontSize={16} />}
      </button>
    </SharePopover>
  );
};
